<template>
    <div>
        <b-toast id="onboarding-warning" variant="warning" solid no-auto-hide :visible="shouldContinue" toaster="b-toaster-bottom-right">
            <template #toast-title>
                <div class="d-flex flex-grow-1 align-items-baseline">
                <strong class="mr-auto">{{ $t('onboarding') }}</strong>
                </div>
            </template>
            
            <p>{{ $t('someFunctionalitiesMayNotBeAvailable') }}</p>

            <b-button variant="warning" size="sm" @click="finish"> {{ $t('finishOnboarding') }} </b-button>

        </b-toast>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String
        },

        shouldContinue: {
            type: Boolean,
            default: false
        },

        onboardingSuccess: {
            type: Boolean,
            default: false
        }
    },

    data: function() {
        return {
            hide: false
        }
    },

    computed: {},

    methods: {
        finish() {
            this.$store.commit("UNPAUSE_ONBOARDING_ALL")
            this.$bvToast.hide('onboarding-warning')
        }
    }
}
</script>

<style scoped>
.onboarding-heading {
    z-index: 9999;
    width: 100%;
}

</style>